const waxUrl = {
	contract: "endlessnftft",
	rpcEndpoint: "https://wax-api.gnocity.io",
	baseAtomicAssets: "https://wax-aa.gnocity.io",
	waxBlocks: "https://wax.bloks.io",
	graymassTableRows: "https://wax.greymass.com",
};

export default waxUrl;
